import { render, staticRenderFns } from "./UrlAttributesPreview.vue?vue&type=template&id=83861fd2&scoped=true&"
import script from "./UrlAttributesPreview.vue?vue&type=script&lang=js&"
export * from "./UrlAttributesPreview.vue?vue&type=script&lang=js&"
import style0 from "./UrlAttributesPreview.vue?vue&type=style&index=0&id=83861fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83861fd2",
  null
  
)

export default component.exports